import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";

export const Logo = () => {
  const { portfolioId } = useParams();
  const navigate = useNavigate();
  return (
    <div
      className="w-32 h-10 cursor-pointer flex items-center"
      onClick={() =>
        navigate(
          portfolioId ? `/portfolio/${portfolioId}/overview` : "/overview"
        )
      }
    >
      <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="logo" />
    </div>
  );
};
